import { env } from "@/api/env"

/**
 * Where DevSMS's public pieces live: the Android app's download (the
 * deployment's DASHBOARD_ANDROID_APK_URL, else the published build) and
 * the service status page.
 */
export const DEFAULT_APK_URL = "https://devsms-bucket.hiis.io/devsms.apk"
export const STATUS_URL = "https://devsms-status.hiis.io"

export const apkUrl = (): string => env.VITE_ANDROID_APK_URL ?? DEFAULT_APK_URL
